import React from "react";
import { Alert } from "react-bootstrap";

export default function SuccessInvitationProcess() {
  return (
    <div className="flex flex-col">
      <Alert
        className="mt-20 max-w-[500px] text-center mx-auto"
        variant="success"
      >
        You have finished the invitation process, you can close this page and return to See4c.
      </Alert>
    </div>
  );
}
